import { Drone } from 'models/drone/Drone';
import api, { CrudRestApi } from '../api';

const apiUrl = 'public/fleet-items';

const rest = CrudRestApi(apiUrl, Drone);

const getDroneStates = async () => {
    const { data } = await api.get(`states`);

    return data;
};

const getDroneMissions = async droneId => {
    const { data } = await api.get(`missions/${droneId}`);
    return data;
};

const getLatestDroneState = async droneId => {
    const { data } = await api.get(`missions/${droneId}`);
    return data;
};

const getLatestDroneMission = async droneId => {
    const { data } = await api.get(`missions/${droneId}`);
    return data;
};

const sendCommand = async (channelId, operationType) => {
    const { data } = await api.get(`commands/${channelId}/${operationType}`);
    return data;
};

const getAllDrones = async () => {
    const { data } = await api.get(`${apiUrl}`);
    return data;
};

const getDrone = async droneId => {
    const { data } = await api.get(`${apiUrl}/${droneId}`);
    return data;
};

const DroneService = {
    ...rest,
    getDroneStates,
    getLatestDroneState,
    getLatestDroneMission,
    getDroneMissions,
    sendCommand,
    getDrone,
    getList: getAllDrones,
};

export default DroneService;
